import Vue from 'vue'
import VueRouter from 'vue-router'

import NProgress from 'nprogress'

import 'nprogress/nprogress.css'

Vue.use(VueRouter)

let router = new VueRouter({
  routes: [
        {
            path: '/',
            name: 'home',
            component: () => import('../views/Home.vue')
        },
        {
            path: '/topic',
            name: 'topic',
            component: () => import('../views/Topic.vue')
        },
        {
            path: '/list',
            name: 'list',
            component: () => import('../views/List.vue')
        },
        {
            path: '/rule',
            name: 'rule',
            component: () => import('../views/Rule.vue')
        },
        {
            path: '/dynamic',
            name: 'dynamic',
            component: () => import('../views/Dynamic.vue')
        },
        {
            path: '/game',
            name: 'game',
            component: () => import('../views/Game.vue')
        },
        {
            path: '/result',
            name: 'result',
            component: () => import('../views/Result.vue')
        }
    ]
})

// router.beforeEach((to, from, next) => {
//     NProgress.start()
//     next()       
// })

// router.afterEach(() => {
//     NProgress.done()
// })

export default router = router;